import CafeItem from 'components/CafeItem';
import React from 'react';

import './cafes.scss';

const Cafes = () => {
  return (
    <main>
      <CafeItem />
    </main>
  );
};

export default Cafes;
